export default {
      id: "ic_dots-usage",
      viewBox: "0 96 960 960",
      url: __webpack_public_path__ + "img/icons.svg#ic_dots",
      toString: function () {
        return this.url;
      }
    }